import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { openLoginModal } from "../../auth/actions";
import { authApi } from "../../auth/api";
import LoginModal from "../../auth/components/LoginModal.web";
import i18next from "../../base/i18n/i18next";
import Footer from "./Footer.web";
import LandingNavbar from "./LandingNavbar";
const SupportPage = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const isAuthenticated = useSelector((state) => state["features/auth"]?.isAuthenticated ?? false);
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        subject: "",
        message: "",
        phoneNumber: "",
    });
    const [toast, setToast] = useState(null);
    // Set document direction based on current language
    useEffect(() => {
        const rtlLanguages = ["fa", "ar", "he"];
        const currentLang = i18next.language || "fa";
        const isRtl = rtlLanguages.includes(currentLang);
        document.documentElement.dir = isRtl ? "rtl" : "ltr";
        document.documentElement.lang = currentLang;
        const handleLanguageChanged = (lng) => {
            const newIsRtl = rtlLanguages.includes(lng);
            document.documentElement.dir = newIsRtl ? "rtl" : "ltr";
            document.documentElement.lang = lng;
        };
        i18next.on("languageChanged", handleLanguageChanged);
        return () => {
            i18next.off("languageChanged", handleLanguageChanged);
        };
    }, []);
    const handleChange = useCallback((e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    }, []);
    const handleSubmit = useCallback((e) => {
        e.preventDefault();
        if (!authApi.isAuthenticated()) {
            dispatch(openLoginModal());
            return;
        }
        authApi
            .submitSupportForm(formData)
            .then(() => {
            setFormData({ name: "", email: "", subject: "", message: "", phoneNumber: "" });
            setToast({ type: "success", message: t("support.successMessage") });
            setTimeout(() => setToast(null), 5000);
        })
            .catch((error) => {
            if (error.message === "TOO_MANY_REQUESTS") {
                setToast({ type: "error", message: t("support.tooManyRequests") });
                setTimeout(() => setToast(null), 5000);
            }
        });
    }, [formData, dispatch]);
    return (React.createElement("div", { className: "static-page support-page" },
        React.createElement(LandingNavbar, null),
        React.createElement(LoginModal, null),
        toast && (React.createElement("div", { className: `support-toast support-toast--${toast.type}` },
            React.createElement("span", null, toast.message),
            React.createElement("button", { className: "support-toast__close", onClick: () => setToast(null), type: "button" }, "\u00D7"))),
        React.createElement("main", { className: "static-page-content" },
            React.createElement("div", { className: "static-page-container" },
                React.createElement("h1", { className: "static-page-title" }, t("support.title")),
                React.createElement("div", { className: "support-content" },
                    React.createElement("div", { className: "support-form-section" },
                        React.createElement("h2", null, t("support.sendMessage")),
                        React.createElement("div", { className: "support-form-wrapper" },
                            !isAuthenticated && (React.createElement("div", { className: "support-login-overlay" },
                                React.createElement("div", { className: "support-login-overlay-content" },
                                    React.createElement("svg", { fill: "none", height: "48", viewBox: "0 0 24 24", width: "48", xmlns: "http://www.w3.org/2000/svg" },
                                        React.createElement("path", { d: "M12 15V17M6 21H18C19.1046 21 20 20.1046 20 19V13C20 11.8954 19.1046 11 18 11H6C4.89543 11 4 11.8954 4 13V19C4 20.1046 4.89543 21 6 21ZM16 11V7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7V11H16Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2" })),
                                    React.createElement("p", null, t("support.loginRequired")),
                                    React.createElement("button", { className: "support-submit-btn", onClick: () => dispatch(openLoginModal()), type: "button" }, t("welcomepage.navbar.loginSignup"))))),
                            React.createElement("form", { className: "support-form", onSubmit: handleSubmit },
                                React.createElement("div", { className: "form-row" },
                                    React.createElement("div", { className: "form-group" },
                                        React.createElement("label", { htmlFor: "name" }, t("support.form.name")),
                                        React.createElement("input", { id: "name", name: "name", onChange: handleChange, required: true, type: "text", value: formData.name })),
                                    React.createElement("div", { className: "form-group" },
                                        React.createElement("label", { htmlFor: "email" }, t("support.form.email")),
                                        React.createElement("input", { id: "email", name: "email", onChange: handleChange, required: true, type: "email", value: formData.email })),
                                    React.createElement("div", { className: "form-group" },
                                        React.createElement("label", { htmlFor: "phoneNumber" }, t("support.form.phonenumber")),
                                        React.createElement("input", { id: "phoneNumber", name: "phoneNumber", onChange: handleChange, required: true, type: "number", value: formData.phoneNumber })),
                                    React.createElement("div", { className: "form-group" },
                                        React.createElement("label", { htmlFor: "subject" }, t("support.form.subject")),
                                        React.createElement("select", { id: "subject", name: "subject", onChange: handleChange, required: true, value: formData.subject },
                                            React.createElement("option", { value: "" }, t("support.form.selectSubject")),
                                            React.createElement("option", { value: "technical" }, t("support.form.subjects.technical")),
                                            React.createElement("option", { value: "feedback" }, t("support.form.subjects.feedback")),
                                            React.createElement("option", { value: "other" }, t("support.form.subjects.other"))))),
                                React.createElement("div", { className: "form-group" },
                                    React.createElement("label", { htmlFor: "message" }, t("support.form.message")),
                                    React.createElement("textarea", { id: "message", name: "message", onChange: handleChange, required: true, rows: 5, value: formData.message })),
                                React.createElement("button", { className: "support-submit-btn", type: "submit" }, t("support.form.submit")))))))),
        React.createElement(Footer, null)));
};
export default SupportPage;
